// MentalHealthTreatmentTable.jsx
import React from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Button,
  Select,
  MenuItem,
} from "@mui/material";

import dayjs from "dayjs";
import DatePickerComponentForBio from "../DatePickerComponentForBio";

const MentalHealthTreatmentTable = ({
  treatments,
  setTreatments,
  noPreviousTreatment,
  setNoPreviousTreatment,
}) => {
  const handleTreatmentChange = (index, field, value) => {
    setTreatments((prev) => {
      const updated = [...prev];
      if (field === "date") {
        const parsedDate = value ? dayjs(value) : null;
        if (parsedDate && !parsedDate.isValid()) {
          console.error(`Invalid date entered:`, value);
          return updated; // Ignore if the date is invalid
        }
        updated[index][field] = parsedDate;
      } else {
        updated[index][field] = value;
      }
      return updated;
    });
  };

  const addTreatmentRow = () => {
    setTreatments((prev) => [
      ...prev,
      { programName: "", type: "", date: null, status: "", otherStatus: "" },
    ]);
  };

  const removeTreatmentRow = (index) => {
    setTreatments((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        style={{
          border: "1px solid lightgrey",
          borderRadius: "5px",
          paddingLeft: "10px",
          marginTop: "10px",
          marginRight: "10px",
          paddingTop: "5px",
          marginBottom: "10px",
        }}
      >
        <Typography>History of Mental Health Treatment:</Typography>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                checked={noPreviousTreatment}
                onChange={() => setNoPreviousTreatment((prev) => !prev)}
              />
            }
            label="No previous treatment"
          />
        </div>
        <div style={{ marginTop: "10px", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={styles.header}>Name of Treatment Program</th>
                <th style={styles.header}>Type of Treatment</th>
                <th style={styles.header}>Date of Treatment</th>
                <th style={styles.header}>Status</th>
                <th style={styles.header}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {treatments.map((treatment, index) => (
                <tr key={index}>
                  <td style={styles.cell}>
                    <TextField
                      value={treatment.programName}
                      onChange={(e) =>
                        handleTreatmentChange(
                          index,
                          "programName",
                          e.target.value
                        )
                      }
                      fullWidth
                      placeholder="Program Name"
                    />
                  </td>
                  <td style={styles.cell}>
                    <Select
                      value={treatment.type}
                      onChange={(e) =>
                        handleTreatmentChange(index, "type", e.target.value)
                      }
                      fullWidth
                    >
                      <MenuItem value="Hospital">Hospital</MenuItem>
                      <MenuItem value="Partial day">Partial day</MenuItem>
                      <MenuItem value="Outpatient">Outpatient</MenuItem>
                    </Select>
                  </td>
                  <td style={styles.cell}>
                    <DatePickerComponentForBio
                      value={treatment.date}
                      onChange={(date) =>
                        handleTreatmentChange(index, "date", date)
                      }
                      placeholderText="Select Date"
                      dateFormat="MM/dd/yyyy"
                      className="datepicker"
                    />
                  </td>
                  <td style={styles.cell}>
                    <Select
                      value={treatment.status}
                      onChange={(e) =>
                        handleTreatmentChange(index, "status", e.target.value)
                      }
                      fullWidth
                    >
                      <MenuItem value="Completed">Completed</MenuItem>
                      <MenuItem value="Dropped Out">Dropped Out</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                    {treatment.status === "Other" && (
                      <TextField
                        value={treatment.otherStatus}
                        onChange={(e) =>
                          handleTreatmentChange(
                            index,
                            "otherStatus",
                            e.target.value
                          )
                        }
                        fullWidth
                        placeholder="Specify Other"
                        style={{ marginTop: "5px" }}
                      />
                    )}
                  </td>
                  <td style={styles.cell}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => removeTreatmentRow(index)}
                    >
                      Remove
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ marginTop: "10px" }}>
        <Button variant="outlined" onClick={addTreatmentRow}>
          Add Row
        </Button>
      </div>
    </div>
  );
};

const styles = {
  header: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "left",
    backgroundColor: "#f0f0f0",
  },
  cell: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "left",
  },
};

export default MentalHealthTreatmentTable;
